import * as React from "react";
import "./styles.scss";
var Footer = function (props) {
    var styles = {
        backgroundColor: props.bgColor,
        color: props.color,
    };
    return (React.createElement("footer", { style: styles, className: "footer ".concat(document.body.scrollHeight < window.screen.height ? "fixed" : "") },
        React.createElement("div", { className: "left-footer-text-container" },
            React.createElement("span", { className: "left-footer-text" }, props.leftFooterText)),
        React.createElement("div", { className: "right-footer-text-container" },
            React.createElement("span", { className: "right-footer-text" }, props.rightFooterText))));
};
Footer.defaultProps = {
    rightFooterText: "\u00A9 ".concat(new Date().getFullYear(), " MyShubhLife. All Rights Reserved.")
};
export default Footer;
//# sourceMappingURL=index.js.map